import { render, staticRenderFns } from "./MovePageDialog.vue?vue&type=template&id=9e1d5402"
import script from "./MovePageDialog.vue?vue&type=script&lang=js"
export * from "./MovePageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports